import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'core-js/modules/es6.string.bold.js';
import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import React__default from 'react';
import cx from 'classnames';

var _excluded = ["bold", "children", "className", "display", "styleLevel", "tagLevel", "text"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var HTMLHeading = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var bold = _ref.bold,
      children = _ref.children,
      className = _ref.className,
      display = _ref.display,
      styleLevel = _ref.styleLevel,
      tagLevel = _ref.tagLevel,
      text = _ref.text,
      props = _objectWithoutProperties(_ref, _excluded);

  var combinedClassName = cx("vds-heading", styleLevel && "vds-".concat(styleLevel), {
    "vds-bold": bold,
    "vds-display": display
  }, className);
  return /*#__PURE__*/React__default.createElement(tagLevel, _objectSpread({
    className: combinedClassName,
    ref: ref
  }, props), text !== null && text !== void 0 ? text : children);
});

export { HTMLHeading };
//# sourceMappingURL=html-heading.js.map
